import Chevron from '@alltrails/shared/icons/Chevron';
import { Department, Posting } from 'components/careers/types';
import getDepartmentLabel from './utils/getDepartmentLabel';

import * as styles from './styles/styles.module.scss';

type JobPostingProps = {
  posting: Posting;
  department: Department;
};

const JobPosting = ({ posting, department }: JobPostingProps): JSX.Element => (
  <a href={posting.url} target="_blank" rel="noreferrer" className={styles.postingContainer}>
    <span className={styles.departmentText}>{getDepartmentLabel(department)}</span>
    <span className={styles.postingTitle}>{posting.text}</span>
    <span className={styles.commitmentText}>{`${posting.commitment}, ${posting.location}`}</span>
    <div className={styles.applyButton}>
      <Chevron orientation="right" size="sm" />
    </div>
  </a>
);

export { JobPosting as default, JobPostingProps };
